<template>
  <div>
    <Head :title="__('Customers')" />
    <div class="flex items-center justify-between mb-6">
      <SearchInput v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset" />
      <Link class="btn-indigo" :href="this.route('customers.create')">
        <span>{{ __('New Customer') }}</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead class="bg-gray-100 text-gray-600 font-semibold uppercase text-xs">
          <tr>
            <th v-for="(h, index) in headers" :key="index" class="px-6 py-3">
              <div v-if="h.sort" class="flex items-center gap-1 cursor-pointer">
                <span
                  :class="{
                    'text-indigo-600': form.field === h.value,
                  }"
                >
                  {{ h.name }}
                </span>
                <div class="icons">
                  <!-- Up arrow -->
                  <icon
                    name="up"
                    class="h-3 w-3 fill-gray-300"
                    :class="{ 'fill-gray-800': form.field === h.value && form.direction === 'asc' }"
                    @click="sort(h.value)"
                  ></icon>
                  <!-- Down arrow -->
                  <icon
                    name="down"
                    class="h-3 w-3 fill-gray-300"
                    :class="{ 'fill-gray-800': form.field === h.value && form.direction === 'desc' }"
                    @click="sort(h.value)"
                  ></icon>
                </div>
              </div>
              <div v-else>
                {{ h.name }}
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="user in users.data"
            :key="user.id"
            class="hover:bg-gray-50 focus-within:bg-gray-50 border-t"
          >
            <td class="px-6 py-4">
              <Link class="btn-indigo" :href="this.route('tickets',{ customer_id: user.tr_id })">
                <span>{{ __('Overzicht') }}</span>
              </Link>
            </td>
            <td class="px-6 py-4">{{ user.contract }}</td>
            <td class="px-6 py-4">{{ user.last_execution_date }}</td>
            <td class="px-6 py-4">{{ user.routename }}</td>
            <td class="px-6 py-4">{{ user.relation }}</td>
            <td class="px-6 py-4">{{ user.name }}</td>
            <td class="px-6 py-4">{{ user.address  }}</td>
            <td class="px-6 py-4">{{ user.postal_code }}</td>
            <td class="px-6 py-4">{{ user.place }}</td>
            <td class="px-6 py-4">{{ user.article }}</td>
            <td class="px-6 py-4">{{ user.prijsrayon }}</td>

            <td class="px-6 py-4">{{ user.end_date }}</td>
            <td class="px-6 py-4">{{ user.first_date }}</td>
            <td class="px-6 py-4">{{ user.relcon }}</td>
          </tr>
          <tr v-if="users.data.length === 0">
            <td class="px-6 py-4 text-center text-gray-500" colspan="13">
              {{ __('No customers found.') }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <Pagination class="mt-6" :links="users.links" />
  </div>
</template>

<script>
import { Head, Link } from "@inertiajs/vue3";
import Icon from "@/Shared/Icon";
import pickBy from "lodash/pickBy";
import Layout from "@/Shared/Layout";
import throttle from "lodash/throttle";
import mapValues from "lodash/mapValues";
import Pagination from "@/Shared/Pagination";
import SearchInput from "@/Shared/SearchInput";

export default {
  components: {
    SearchInput,
    Head,
    Icon,
    Link,
    Pagination,
  },
  layout: Layout,
  props: {
    filters: Object,
    users: Object,
    links: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
      },
      headers: [
        { name: 'Ticket overzicht', value: null, sort: false },

        { name: 'Contract', value: 'contract', sort: true },
        { name: 'Laatste Uitvoering', value: 'last_execution_date', sort: true },
        { name: 'Routenaam', value: 'routename', sort: true },
        { name: 'Relatie', value: 'relation', sort: true },
        { name: 'Naam', value: 'name', sort: true },
        { name: 'Adres', value: 'address', sort: true },
        { name: 'Postcode', value: 'postal_code', sort: true },
        { name: 'Plaats', value: 'place', sort: true },
        { name: 'Artikel', value: 'article', sort: true },
        { name: 'Prijsrayon', value: 'prijsrayon', sort: true },
        { name: 'Einddatum', value: 'end_date', sort: true },
        { name: 'First Date', value: 'first_date', sort: true },
        { name: 'Relcon', value: 'relcon', sort: true },
      ],
      form: {
        search: this.filters.search,
        field: this.filters.field || null,
        direction: this.filters.direction || 'asc',
      },
    };
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get(
          this.route("customers"),
          pickBy(this.form), 
          { preserveState: true }
        );
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null);
    },
    sort(field) {
      if (this.form.field === field) {
        this.form.direction = this.form.direction === 'asc' ? 'desc' : 'asc';
      } else {
        this.form.field = field;
        this.form.direction = 'asc';
      }
    },
  },
};
</script>
